import React from 'react';
import PropTypes from 'prop-types';
import ProductInstructions from "../../StandardItems/ProductInstructions";
import SkuDisplay from "../../../../Common/components/SkuDisplay";
import NapaSkuDisplay from "../../StandardItems/NapaSkuDisplay";

import EmbeddedConfig from "../../../../lib/EmbeddedConfig";
import {camelizeKeysDeep} from "../../../../ReduxStore/Helpers/transformObject";
import clsx from "clsx";

const isDev = (process.env.NODE_ENV == 'development');

/**
 * In the center column of the cluster widget.
 *
 * Camelizes its item prop.
 *
 * @returns {JSX.Element|null}
 * @constructor
 */
export default function SelectedItemDetail({item}) {
  item = camelizeKeysDeep(item);

  const {product} = item;
  const conf = EmbeddedConfig.instance();
  const showNapaSku = conf.fetch('name') === 'napaonline';

  if (!product) {
    console.error("selected item detail: no item.product", item);
    return null;
  }

  let status = product.buyableStatus;
  let oos = (status === 'out_of_stock') || (status === 'discontinued');

  let listStyles = "list-disc pl-0 ml-0";

  return <div className="pt-2">
    <ul className="list-disc list-inside p-0">
      {oos && <li className={clsx(listStyles, "text-red-800 font-bold")}>
        {product.vendorsku} is out of stock.
        Please select another option.
      </li>}

      {getBullets(item).map((txt, i) =>
        <li className={listStyles} key={i}>{txt}</li>)}

      {getFootnotes(item).map((f, i) =>
        <li className={listStyles} key={i}>{f}</li>)}

      <SkuDisplay sku={product.vendorsku} tagName="li"/>

      {showNapaSku && <NapaSkuDisplay product={product} tagName="li"/>}
    </ul>

    <ProductInstructions path={product.instructionsPath} tagName="div"/>
  </div>
}

SelectedItemDetail.propTypes = {
  item: PropTypes.object.isRequired   // AppliedItem with keys {application, product}
}

function getFootnotes(item) {
  const {application = {}} = item;

  const {footnote} = application;

  // if (isDev)
  //   return [ "foot 1", "foot 2"];

  // footnotes have @@ as internal delimiter.
  // example: NF Neosupreme Seat Covers, 2019 Audi A3, Sedan, Low Back, Grey/Black
  return footnote ? ("" + footnote).split(/@@/) : [];
}

function getBullets(item) {
  const {product} = item;

  // if (isDev)
  //   return [ "bull 1", "bull 2"];

  if (!product || !product.bullets)
    return [];

  return ("" + product.bullets).split(/@@/);
}
